import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import React from "react";
import { BarChart3, ShieldCheck, Warehouse, Truck, Settings2, ClipboardList } from "lucide-react";
import a from "./UserAccessEditor.module.scss";

export const ACCESS_GROUPS = [
  {
    key: "reports", title: "Отчёты", icon: BarChart3,
    description: "Просмотр показателей, диаграмм и отчётов.",
    fields: [["reports", "Доступ к отчётам"]],
  },
  {
    key: "admin", title: "Админ панель", icon: ShieldCheck,
    description: "В меню появятся только разрешённые разделы.",
    groups: [
      {
        key: "guards", title: "Охрана КПП", icon: ShieldCheck,
        description: "Каждое действие разрешается отдельно.",
        fields: [["guards", "Просмотр и редактирование охраны"], ["guards_pin", "Сброс PIN охраны"], ["guards_inn", "Смена ИНН охраны"]],
      },
      {
        key: "objects", title: "Объекты и перевозки", icon: Warehouse,
        fields: [["top_bases", "ТОП-базы"], ["chpps", "ТЭЦ"], ["private_points", "Социальные объекты и МСУ"], ["loads", "Погрузки"], ["operators_pin", "Сброс PIN оператор"], ["operators_inn", "Смена ИНН операторам"], ["branches_delete", "Удаление филиалов"]],
      },
      {
        key: "drivers", title: "Транспорт", icon: Truck,
        description: "Каждое действие разрешается отдельно.",
        fields: [["drivers", "Просмотр списка и карточек"], ["drivers_edit", "Редактирование водителей"], ["drivers_pin", "Сброс PIN"], ["drivers_block", "Блокировка и разблокировка"], ["drivers_active", "Изменение активности водителей"], ["drivers_inn", "Смена ИНН водителям"], ["drivers_assign", "Переназначение водителей"], ["drivers_base_assign", "Назначение базы"], ["drivers_base_change", "Смена базы"], ["drivers_base_remove", "Снятие с базы"]],
      },
      {
        key: "management", title: "Управление и контроль", icon: Settings2,
        fields: [["users", "Управление пользователями"], ["audit", "Просмотр журнала действий"]],
      },
    ],
  },
  {
    key: "requests", title: "Заявки", icon: ClipboardList,
    description: "Работа с заявками на базы, регистрацией и документами.",
    fields: [["requests", "Просмотр заявок и исправления"], ["confirmations", "Подтверждение заявок и документов"]],
  },
];
export const ACCESS_FIELDS = ACCESS_GROUPS.flatMap(section => section.fields || section.groups.flatMap(group => group.fields));

export default function UserAccessEditor({ grants, isSuperuser, isReportOnly, onChange }) {
  useInterfaceLanguage();
  const disabled = isSuperuser || isReportOnly;
  const checked = key => isSuperuser || (isReportOnly ? key === "reports" : !!grants[key]);
  const fields = items => (
    <div className={a.checks}>
      {items.map(([key, label]) => (
        <label key={key} className={`${a.permission} ${checked(key) ? a.selected : ""} ${disabled ? a.locked : ""}`}>
          <input type="checkbox" checked={checked(key)} disabled={disabled} onChange={event => onChange(key, event.target.checked)} />
          <span>{tr(label)}</span>
        </label>
      ))}
    </div>
  );
  return (
    <div className={a.sections}>
      {ACCESS_GROUPS.map(section => {
        const Icon = section.icon;
        const allFields = section.fields || section.groups.flatMap(group => group.fields);
        const selected = allFields.filter(([key]) => checked(key)).length;
        return (
          <fieldset className={a.section} key={section.key}>
            <legend><Icon size={16} aria-hidden="true" />{tr("Раздел «")}{tr(section.title)}»</legend>
            <div className={a.sectionSummary}>
              <p>{tr(section.description)}</p>
              <span className={a.count} aria-label={tr("Выбрано разрешений: {{value0}} из {{value1}}", { value0: selected, value1: allFields.length })}>{tr(selected)} / {tr(allFields.length)}</span>
            </div>
            {section.fields ? fields(section.fields) : section.groups.map(group => {
              const GroupIcon = group.icon;
              return (
                <fieldset key={group.key} className={a.subsection}>
                  <legend><GroupIcon size={14} aria-hidden="true" />{tr(group.title)}</legend>
                  {tr(group.description && <p>{tr(group.description)}</p>)}
                  {fields(group.fields)}
                </fieldset>
              );
            })}
          </fieldset>
        );
      })}
    </div>
  );
}
